import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
import Group from './components/Group';
const CheckboxContainer = styled.div `
  display: inline-flex;
  cursor: pointer;
`;
export const HiddenCheckbox = styled.input `
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &[disabled] + * {
    background-color: ${({ theme }) => theme.colors.grey10_1};
    &:hover {
      border-color: ${({ theme }) => theme.colors.grey10_1};
      cursor: not-allowed;
    }
  }
`;
const StyledCheckbox = styled.div `
  display: inline-flex;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 30px;
  height: 18px;
  background: ${({ theme }) => theme.colors.grey00_7};
  border-radius: 30px;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  transition: all 100ms;
  &:hover {
    border-color: ${({ theme }) => theme.colors.grey70_1};
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    top: 1px;
    left: ${({ checked }) => (checked ? '13px' : '1px')};
    background: ${({ theme }) => theme.colors.main};
    transition: all 150ms ease-out;
    background-color: ${({ theme, disabled, $uncheckSwitchColor, checked }) => disabled ? theme.colors.grey30_1 : $uncheckSwitchColor && !checked ? theme.colors.grey70_1 : theme.colors.main};
  }
`;
const CheckboxSwitcher = ({ className, checked, uncheckSwitchColor, ...props }) => (_jsxs(CheckboxContainer, { className: className, children: [_jsx(HiddenCheckbox, { type: 'checkbox', checked: checked, ...props }), _jsx(StyledCheckbox, { checked: checked || false, disabled: props.disabled, $uncheckSwitchColor: uncheckSwitchColor })] }));
const CheckboxSwitcherMemo = React.memo(CheckboxSwitcher);
const CheckboxSwitcherWrapper = (props) => _jsx(CheckboxSwitcherMemo, { ...props });
CheckboxSwitcherWrapper.Group = Group;
export { CheckboxSwitcherWrapper as CheckboxSwitcher };
